import { render, staticRenderFns } from "./IndustrieStandard.vue?vue&type=template&id=48d3d31b&"
import script from "./IndustrieStandard.vue?vue&type=script&lang=js&"
export * from "./IndustrieStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports